import { render, staticRenderFns } from "./u-dialog.vue?vue&type=template&id=86cf3b84&scoped=true&"
import script from "./u-dialog.vue?vue&type=script&lang=js&"
export * from "./u-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cf3b84",
  null
  
)

export default component.exports